/**
 *
 * UserMaleBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import UserMaleIcon from '../../../../assets/v2/UserMaleIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.skyBlueDark};
    background: ${COLORS.skyBlueLight};
    border-color: ${COLORS.skyBlue};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.skyBlueDark};
    }
  }
`;

function UserMaleBadge(props) {
  return <StyledBadge label="Male" icon={<UserMaleIcon />} {...props} />;
}

export default memo(UserMaleBadge);
